var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.668 4.16667H14.0263L12.993 3.04167C12.6846 2.7 12.2346 2.5 11.768 2.5H8.23464C7.76797 2.5 7.31797 2.7 7.0013 3.04167L5.9763 4.16667H3.33464C2.41797 4.16667 1.66797 4.91667 1.66797 5.83333V15.8333C1.66797 16.75 2.41797 17.5 3.33464 17.5H16.668C17.5846 17.5 18.3346 16.75 18.3346 15.8333V5.83333C18.3346 4.91667 17.5846 4.16667 16.668 4.16667ZM10.0014 8.16664C8.62067 8.16664 7.50138 9.28593 7.50138 10.6666C7.50138 12.0474 8.62067 13.1666 10.0014 13.1666C11.3821 13.1666 12.5014 12.0474 12.5014 10.6666C12.5014 9.28593 11.3821 8.16664 10.0014 8.16664ZM5.83464 10.667C5.83464 12.967 7.7013 14.8337 10.0013 14.8337C12.3013 14.8337 14.168 12.967 14.168 10.667C14.168 8.367 12.3013 6.50033 10.0013 6.50033C7.7013 6.50033 5.83464 8.367 5.83464 10.667Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapture);
export default __webpack_public_path__ + "static/media/capture.656ec42f.svg";
export { ForwardRef as ReactComponent };